import { createAsyncThunk } from '@reduxjs/toolkit';

import type { GroupUpdateRequest, GroupDto } from '../../api/types';
import { entitiesActions } from '../slices/entitiesSlice';
import type { RootState } from '../store';

import { groupsService } from './_deps';

export type UpdateGroupParams = {
  groupId: string;
  payload: GroupUpdateRequest;
};

export const updateGroup = createAsyncThunk<GroupDto, UpdateGroupParams, { state: RootState }>(
  'groups/update',
  async ({ groupId, payload }, thunkApi) => {
    const { dispatch, getState } = thunkApi;

    try {
      const group = await groupsService.updateGroup({ groupId, payload });
      dispatch(entitiesActions.upsertGroups([group]));
      return group;
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Не удалось обновить группу';
      throw error;
    }
  },
);
